export const cargos = [
    'Sócio/Proprietário',
    'Diretor/Gerente (Matriz)',
    'Diretor/Gerente (Filial)',
    'Comprador',
    'Outros'
]

//old one
//'Auxiliar',
//    'Executivo',
//    'Vendedor',
//    'Analista',
//    'Consultor',
//    'Coordenador',
//    'Supervisor',
//    'Gerente',
//   'Diretor'